import { Tag } from 'antd'
import React from 'react'
import { _listType, getColor } from 'styles/colors'

export function renderBadge (value: string | undefined, list: _listType) {
  if (!value || value === '-') return <Tag>-</Tag>
  return <div className="text-center"><Tag className="text-center capitalize mr-0" color={getColor(value, list)}>{value}</Tag></div>
}
